import React from "react";

export const Skeleton = ({ width = "100%", height = 16, radius = 6, style }) => (
  <span
    className="skeleton"
    style={{
      display: "inline-block",
      width,
      height,
      borderRadius: radius,
      ...style,
    }}
  />
);

export const TableSkeleton = ({ rows = 6, cols = 5 }) => (
  <div className="card" style={{ padding: 0, overflow: "hidden" }}>
    <div style={{ padding: "12px 16px", borderBottom: "1px solid var(--border)" }}>
      <Skeleton width={160} height={14} />
    </div>
    {Array.from({ length: rows }).map((_, r) => (
      <div
        key={r}
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
          gap: 12,
          padding: "12px 16px",
          borderBottom: "1px solid var(--border)",
        }}
      >
        {Array.from({ length: cols }).map((__, c) => (
          <Skeleton key={c} width={c === 0 ? "60%" : "85%"} height={14} />
        ))}
      </div>
    ))}
  </div>
);

export default Skeleton;
